import * as React from "react";
import * as Mui from "@material-ui/core";

import { ChangelogModalDialogPaper } from "./ChangelogModal.styles";
import { BaseModal } from "Components/Modal/BaseModal";
import { DefaultButton } from "Components/Buttons/Buttons";

interface IProps {
    open?: boolean;
    onClose(): void;
    title: string;
}

export const ChangelogModal: React.FC<IProps> = ({ open, onClose, title, children }) => (
    <BaseModal
        open={open}
        onClose={onClose}
        title={title}
        PaperComponent={ChangelogModalDialogPaper}
        actions={
            <>
                <DefaultButton execute={onClose} displayName={"Close"} canExecute={true} />
            </>
        }
    >
        {children}
    </BaseModal>
);
